import { Routes } from "@angular/router";
import { customerRoutes } from "@app/applications/customer/customer.routes";
import { authRoutes } from "@app/applications/auth/auth.routes";
import { QueueLayoutComponent } from "@shared-core/general/queue/layout/queue-layout/queue-layout.component";
import { QueueLayoutAbstraction } from "@shared-core/general/queue/abstractions/queue-layout.abstraction";
import { GuestLayoutComponent } from "@app/shared/general/layouts/guest-layout/guest-layout.component";
import { QueueLayoutService } from "@app/shared/queue/services/queue-layout.service";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";

export const routes: Routes = [
  { path: "", redirectTo: "auth/unauthorized", pathMatch: "full" },
  {
    path: "auth",
    component: GuestLayoutComponent,
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.CUSTOMER.SHARED]),
    },
    children: [...authRoutes],
  },
  {
    path: "",
    component: QueueLayoutComponent,
    providers: [{ provide: QueueLayoutAbstraction, useClass: QueueLayoutService }],
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.CUSTOMER.SHARED]),
    },
    children: [
      {
        path: "customer",
        children: [...customerRoutes],
      },
    ],
  },
  { path: "**", redirectTo: "auth/unauthorized" },
];
